var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('aside',{attrs:{"id":"aside-menu"}},[_c('section',[_c('ul',{staticClass:"sidebar-menu"},_vm._l((_vm.menu),function(item){return _c('li',{key:item.name},[_c('a',{attrs:{"href":item.path}},[(_vm.mobile)?_c('span',[_vm._v(_vm._s(item.name[0]))]):_c('span',[_vm._v(_vm._s(item.name))])])])}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }